import React, { useEffect, useState } from "react";
import EmployeeProcessService from "../services/EmployeeProcessService";
import { useLoading } from "../Utils/LoadingContext";

const ExecuteProcedurePage = () => {
  const { setLoading } = useLoading();

  const empcode = localStorage.getItem("empcode");

  const [plantList, setPlantList] = useState([]);
  const [selectedPlantId, setSelectedPlantId] = useState("");

  // 🔹 Load Plant dropdown on mount
  useEffect(() => {
    loadPlants();
  }, []);

  const loadPlants = async () => {
    try {
      const plantRes = await EmployeeProcessService.getPlant(empcode);
      if (plantRes?.data?.statusCode === 200) {
        setPlantList(plantRes.data.result);
      }
    } catch (error) {
      console.error("Error loading plants:", error);
    }
  };

  // 🔹 Handle single selection
  const handlePlantChange = (e) => {
    setSelectedPlantId(e.target.value);
  };

  // 🔹 Execute Procedure
  const handleExecute = async () => {
    // 🔹 Special rule: empcode 107086 can pass blank plant
    if (empcode !== "107086" && !selectedPlantId) {
      alert("⚠️ Please select a Plant!");
      return;
    }
// Decide PlantID correctly
  const plantIdToSend =
    empcode === "107086"
      ? (selectedPlantId ? Number(selectedPlantId) : null) // allow null
      : Number(selectedPlantId); // mandatory for others
    try {
      setLoading(true);
debugger;
      const response = await EmployeeProcessService.ExecutProcedure(
        "",
        plantIdToSend || "" // pass blank if empcode 107086
      );

      if (response?.data?.statusCode === 200) {
        alert("✅ Procedure executed successfully!");
      } else {
        alert("⚠️ Failed to execute procedure!");
      }
    } catch (error) {
      console.error(error);
      alert("❌ An error occurred while executing the procedure.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <h4 className="text-primary mb-3">Refresh Data</h4>
      <div className="row mb-3">
        {/* Plant Dropdown */}
        <div className="col-md-3">
          <label className="text-primary">Plant</label>
          <select
              className="form-select"
            value={selectedPlantId}
            onChange={handlePlantChange}
          >
            <option value="">-- Select Plant --</option>
            {plantList.map((plant) => (
              <option key={plant.id} value={plant.id}>
                {plant.name}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-2 d-flex align-items-end">
          <button
            onClick={handleExecute}
            className="btn btn-success">
            Run
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExecuteProcedurePage;
